import React, { useState } from "react";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import Moment from "moment";

import { Content } from "./styles";

function VisaoGeralGerenciamento(data: any) {
  const [month, setMonth] = useState(Moment());

  const processData = [
    {
      aprovados: 0,
      pendentes: 0,
      reprovados: 0,
    },
  ];

  return (
    <Content>
      <div className="content-wrapper">
        <div className="header">
          <p>Visão geral dos processos</p>
          <div className="filter">
            <button
              onClick={() => setMonth(Moment(month).subtract(1, "month"))}
            >
              <FiArrowLeft id="icon" />
            </button>
            <p>{month.format("MMMM")}</p>
            <button onClick={() => setMonth(Moment(month).add(1, "month"))}>
              <FiArrowRight id="icon" />
            </button>
          </div>
        </div>
        {processData?.map((process: any) => {
          return (
            <div key = {process.id} className="bellow-header">
              <div className="approveds">
                <p id="numb-apr">{process.aprovados}</p>
                <p id="apr">Aprovados</p>
              </div>
              <div className="pending">
                <p id="numb-pending">{process.pendentes}</p>
                <p id="apr">Pendentes</p>
              </div>
              <div className="disapproved">
                <p id="numb-disapproved">{process.reprovados}</p>{" "}
                <p id="apr">Reprovados</p>
              </div>
            </div>
          );
        })}
      </div>
    </Content>
  );
}

export default VisaoGeralGerenciamento;
